"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _themeContants = require("../../../constants/themeContants");

var _theming = require("../../../theming");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The flag object is a design pattern similar to the media object, however it
 * utilises `display: table[-cell];` to give us control over the vertical
 * alignments of the text and image.
 */
var Flag = function Flag(_ref) {
  var children = _ref.children,
      className = _ref.className,
      img = _ref.img,
      reverse = _ref.reverse,
      top = _ref.top,
      bottom = _ref.bottom,
      responsive = _ref.responsive,
      flush = _ref.flush,
      large = _ref.large,
      small = _ref.small,
      tiny = _ref.tiny,
      otherProps = _objectWithoutProperties(_ref, ["children", "className", "img", "reverse", "top", "bottom", "responsive", "flush", "large", "small", "tiny"]);

  return _react["default"].createElement(FlagObject, _extends({
    className: className,
    reverse: reverse,
    top: top,
    bottom: bottom,
    responsive: responsive,
    flush: flush,
    large: large,
    small: small,
    tiny: tiny
  }, otherProps), _react["default"].createElement(FlagImg, null, img), _react["default"].createElement(FlagBody, null, children));
};

Flag.themeProps = {
  object: {
    name: "FLAG_OBJECT",
    description: "",
    type: _themeContants.themePropTypes.style
  }
};

var FlagImg = _styledComponents["default"].div.withConfig({
  displayName: "Flag__FlagImg",
  componentId: "lmfo8i-0"
})(["margin-right:", ";> svg{display:block;}"], _theming.spacing.medium);

var FlagBody = _styledComponents["default"].div.withConfig({
  displayName: "Flag__FlagBody",
  componentId: "lmfo8i-1"
})(["flex:1 1 0%;&,>:last-child{margin-bottom:0;}"]);

var reverse = (0, _styledComponents.css)(["> ", "{order:1;margin-right:0;margin-left:", ";}"], FlagImg, _theming.spacing.medium);
var reverseLarge = (0, _styledComponents.css)(["> ", "{margin-right:0;margin-left:", ";}"], FlagImg, _theming.spacing.large);
var reverseSmall = (0, _styledComponents.css)(["> ", "{margin-right:0;margin-left:", ";}"], FlagImg, _theming.spacing.small);
var reverseTiny = (0, _styledComponents.css)(["> ", "{margin-right:0;margin-left:", ";}"], FlagImg, _theming.spacing.tiny);
var top = (0, _styledComponents.css)(["align-items:flex-start;"]);
var bottom = (0, _styledComponents.css)(["align-items:flex-end;"]);
var flush = (0, _styledComponents.css)(["> ", "{padding-right:0;padding-left:0;}"], FlagImg);
var large = (0, _styledComponents.css)(["> ", "{margin-right:", ";}", ";"], FlagImg, _theming.spacing.large, function (props) {
  return props.reverse ? reverseLarge : null;
});
var small = (0, _styledComponents.css)(["> ", "{margin-right:", ";}", ";"], FlagImg, _theming.spacing.small, function (props) {
  return props.reverse ? reverseSmall : null;
});
var tiny = (0, _styledComponents.css)(["> ", "{margin-right:", ";}", ";"], FlagImg, _theming.spacing.tiny, function (props) {
  return props.reverse ? reverseTiny : null;
});
var responsive = (0, _styledComponents.css)(["@media screen and (max-width:", "px){display:block;> ", ",> ", "{display:block;margin:0;}> ", "{width:auto;margin-bottom:", ";}", " > img{max-width:100%;}}"], function (props) {
  return props.responsive;
}, FlagImg, FlagBody, FlagImg, _theming.spacing.medium, FlagImg);

var FlagObject = _styledComponents["default"].div.withConfig({
  displayName: "Flag__FlagObject",
  componentId: "lmfo8i-2"
})(["display:flex;align-items:center;", ";", ";", ";", ";", ";", ";", ";", ";", ";"], function (props) {
  return props.reverse ? reverse : null;
}, function (props) {
  return props.top ? top : null;
}, function (props) {
  return props.bottom ? bottom : null;
}, function (props) {
  return props.flush ? flush : null;
}, function (props) {
  return props.large ? large : null;
}, function (props) {
  return props.small ? small : null;
}, function (props) {
  return props.tiny ? tiny : null;
}, function (props) {
  return props.responsive > 0 ? responsive : null;
}, (0, _theming.applyVariants)(Flag.themeProps.object));

Flag.defaultProps = {
  className: "",
  reverse: null,
  top: null,
  bottom: null,
  responsive: 0,
  flush: null,
  large: null,
  small: null,
  tiny: null
};
Flag.propTypes = {
  children: _themeContants.commonPropTypes.children.isRequired,
  img: _themeContants.commonPropTypes.children.isRequired,
  className: _propTypes["default"].string,
  reverse: _propTypes["default"].bool,
  top: _propTypes["default"].bool,
  bottom: _propTypes["default"].bool,
  responsive: _propTypes["default"].number,
  flush: _propTypes["default"].bool,
  large: _propTypes["default"].bool,
  small: _propTypes["default"].bool,
  tiny: _propTypes["default"].bool
};
var _default = Flag;
exports["default"] = _default;